import React, { useState } from "react";
import { ListTable } from "../Table/listTable/listTable";
import { Card } from "../card";
import { useParentsList } from "../../hooks/parentsHooks/useParentsList.hooks";
import { useNavigate } from "react-router-dom";
import { SearchInput } from "../input/searchInput";
import { Button } from "../Button";
import { transformParentsListTableData } from "../../Services/transformer/transformParentsListTableData";
import { Paths } from "../../Constants/paths";
import { ParentNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";
import { parentsListTitle } from "../../Constants/tableTitles/ListTableTitle/parentsList.titles";

export const ParentsList = () => {
  const navigate = useNavigate();

  const [userName, setUserName] = useState<string>("");
  const [userId, setUserId] = useState<string>("");
  const [userNameToSearch, setUserNameToSearch] = useState<string>("");
  const [userIdToSearch, setUserIdToSearch] = useState<string>("");

  const [pageToSearch, setPageToSearch] = useState(1);

  const { isLoading, data } = useParentsList({
    page: pageToSearch,
    userNameToSearch,
    userIdToSearch,
  });

  return (
    <Card cardTitle="Parents list">
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-x-8 gap-y-4 mb-10">
        <SearchInput
          placeHolder="User Id"
          value={userId}
          setValue={(value) => setUserId(value as string)}
        />
        <SearchInput
          placeHolder="Name"
          value={userName}
          setValue={(value) => setUserName(value as string)}
        />
        <div></div> {/* THIS IS JUST TO MAKE A PROPER SPAN */}
        <div className="w-full col-span-1 flex justify-end">
          <Button
            loading={isLoading}
            text="Search"
            onClick={() => {
              setPageToSearch(
                1
              ); /*  This is necessary as it calls the api multiple time */
              setUserIdToSearch(userId);
              setUserNameToSearch(userName);
            }}
          />
        </div>
      </div>
      <ListTable
        titles={parentsListTitle}
        data={data?.result}
        isDataLoading={isLoading}
        transformFn={transformParentsListTableData}
        pagination={{
          totalPage: data?.lastPage,
          onPageChange: (pageNo) => {
            setPageToSearch(pageNo);
          },
        }}
        onRowClick={(data: any) => {
          navigate(
            `${Paths.ParentsDetail}?section=${ParentNavigationHeader.PARENT_INFO}&parentId=${data.id}`
          );
        }}
      />
    </Card>
  );
};
